module.exports = __webpack_public_path__ + "img/clouds.7d38935e.jpg";